import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import GiftCardNotification from './GiftCardNotification';
import styled from 'styled-components';
import { markNotificationRead } from '../../store/slices/giftCardsSlice';

const NotificationContainer = styled.div`
  position: fixed;
  top: 20px;
  right: 20px;
  z-index: 1000;
  max-width: 400px;
  max-height: 80vh;
  overflow-y: auto;
`;

/**
 * Toast UI only. Gift notification fetching/polling lives in Header
 * (shared Redux giftCards slice) so /api/wallet/giftcards/notifications/
 * is hit once per interval, not twice.
 */
const GiftCardNotificationManager = () => {
  const dispatch = useDispatch();
  const notifications = useSelector((state) => state.giftCards.notifications) || [];
  const [dismissedIds, setDismissedIds] = useState(() => new Set());

  const unreadNotifications = notifications.filter(
    (n) => !n.is_read && !dismissedIds.has(n.id)
  );

  const markAsRead = (notificationId) => {
    dispatch(markNotificationRead(notificationId));
  };

  const removeNotification = (notificationId) => {
    setDismissedIds((prev) => {
      const next = new Set(prev);
      next.add(notificationId);
      return next;
    });
  };

  if (unreadNotifications.length === 0) {
    return null;
  }

  return (
    <NotificationContainer>
      {unreadNotifications.map((notification) => (
        <GiftCardNotification
          key={notification.id}
          notification={notification}
          onClose={removeNotification}
          onMarkRead={markAsRead}
        />
      ))}
    </NotificationContainer>
  );
};

export default GiftCardNotificationManager;
